import React from 'react';
import { AlertTriangle, BriefcaseBusiness, Megaphone, ShieldCheck, TrendingUp } from 'lucide-react';

const businessDevelopmentCards = [
  {
    icon: BriefcaseBusiness,
    title: 'Issuer Pipeline & Review',
    label: 'Business development',
    text: 'Tangibl3Net helps qualify issuers, fiduciaries, producers, NGOs, and asset sponsors before launch. The process starts with the issuer file, legal instrument, responsible parties, evidence, and certificate workflow.',
  },
  {
    icon: TrendingUp,
    title: 'Partner Fee-Covering Program',
    label: 'Capital partners',
    text: 'Selected capital partners may cover up to 50% of an issuer’s Tangibl3Net platform and business-development fees for 2-5 years under a separate agreement with the issuer.',
  },
  {
    icon: Megaphone,
    title: 'Quarterly Marketing Prize',
    label: 'Market visibility',
    text: 'One qualified certificate program may receive a USD 10,000 marketing prize each quarter for positioning, landing-page copy, data-room preparation, campaign planning, educational content, and partner-facing materials. T&C apply.',
  },
];

const LegalPerimeter = () => (
  <section id="legal-perimeter" className="py-16 border-t border-border bg-muted/20">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="rounded-2xl border border-border bg-card p-8 lg:p-10 shadow-sm">
        <div className="flex flex-col lg:flex-row gap-6 lg:items-start lg:justify-between">
          <div className="max-w-3xl">
            <div className="section-label mb-4">What Tangibl3Net Does Not Do</div>
            <h2 className="font-display text-3xl lg:text-4xl font-bold tracking-tight text-foreground">
              Clear role separation before any certificate program moves forward.
            </h2>
            <p className="mt-5 text-base lg:text-lg text-muted-foreground leading-relaxed">
              Tangibl3Net is not the issuer, broker, dealer, exchange, custodian, trustee, asset manager, guarantor, investment adviser, or marketplace unless separately licensed or contractually appointed.
            </p>
            <p className="mt-4 text-base lg:text-lg text-muted-foreground leading-relaxed">
              Tangibl3Net provides issuer review, platform operations, wallet-infrastructure integration, recordkeeping, compliance workflow, beneficiary ledgers, and controlled transaction administration.
            </p>
          </div>
          <div className="grid gap-3 min-w-[240px]">
            <div className="flex items-center gap-3 rounded-xl border border-border bg-background p-4">
              <ShieldCheck className="w-5 h-5 text-primary" />
              <span className="font-mono text-xs uppercase tracking-wider text-foreground">Platform operator</span>
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-border bg-background p-4">
              <AlertTriangle className="w-5 h-5 text-amber-500" />
              <span className="font-mono text-xs uppercase tracking-wider text-foreground">Human review required</span>
            </div>
          </div>
        </div>

        <div id="business-development" className="mt-10 border-t border-border pt-8">
          <div className="section-label mb-4">Business Development</div>
          <h3 className="font-display text-2xl lg:text-3xl font-bold tracking-tight text-foreground">
            Help for serious issuers, not open token promotion.
          </h3>
          <p className="mt-3 text-sm lg:text-base text-muted-foreground leading-relaxed max-w-3xl">
            Tangibl3Net combines issuer review, partner-backed fee coverage, and selected marketing support. These programs are optional and require separate approval.
          </p>
          <div className="mt-6 grid lg:grid-cols-3 gap-4">
            {businessDevelopmentCards.map((card) => (
              <article key={card.title} className="rounded-xl border border-border bg-background p-5">
                <card.icon className="w-5 h-5 text-primary mb-3" />
                <span className="rounded-full border border-primary/30 bg-primary/10 px-2.5 py-1 font-mono text-[10px] uppercase tracking-wider text-primary">
                  {card.label}
                </span>
                <h4 className="mt-4 font-display font-semibold text-foreground">{card.title}</h4>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{card.text}</p>
              </article>
            ))}
          </div>
          <p className="mt-5 text-xs leading-relaxed text-muted-foreground">
            Fee coverage, partner participation, marketing support, and the USD 10,000 quarterly marketing prize are optional business-development arrangements. They do not imply investment approval, guaranteed funding, regulatory approval, liquidity, or asset quality. Eligibility, diligence, and terms are handled separately for each issuer program.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default LegalPerimeter;
